var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsotipo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00003D;}\r\n\t.st1{fill:#306AB2;}\r\n\t.st2{fill:#FF9100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M248.6,31.8v42.4c-13.7-21.7-33.8-38.9-57.7-49.1c3-0.2,6-0.2,9.1-0.2C216.9,25,233.2,27.4,248.6,31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375,200c0,72.5-44.1,134.7-106.9,161.3c-3.2,1.4-6.4,2.6-9.7,3.8c-3.2,1.1-6.4,2.2-9.7,3.1 c-15.4,4.5-31.7,6.8-48.6,6.8s-33.2-2.4-48.6-6.8V267.7c41-3.1,76.5-25.8,97.2-58.6c3.7-5.9,7-12.2,9.7-18.7 c6.3-15,9.7-31.4,9.7-48.7V38.7C330.9,65.3,375,127.5,375,200z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.6,141.7c0,55.8-42.7,101.6-97.2,106.5c-3.2,0.3-6.4,0.4-9.7,0.4c-3.3,0-6.5-0.1-9.7-0.4v113.1 C69.1,334.7,25,272.5,25,200c0-3.1,0.1-6.1,0.2-9.1c0.4-7.8,1.3-15.5,2.7-23.1c1.6-8.8,3.9-17.3,6.8-25.5 C51,95.6,86.6,57.9,131.9,38.7c3.2-1.4,6.4-2.6,9.7-3.8c0.2-0.1,0.4-0.2,0.7-0.2c3.1,0,6.1,0.2,9.1,0.4 C205.9,40.1,248.6,85.9,248.6,141.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo);
export default __webpack_public_path__ + "static/media/isotipo.895a166c3de8657bab64c90bcae8978b.svg";
export { ForwardRef as ReactComponent };